/// <amd-module name="Wit/Portal/Redux/WorkItemPortalSaga" />
import { effects, SagaIterator } from "redux-saga";
import { ActionsOfType } from "redux/Utils/ActionHelper";
import { WorkItemActions, WorkItemActionTypes } from "Wit/WorkItems/WorkItemActions";
import { WorkItemPortalActions } from "./WorkItemPortalActions";

export function* workItemPortalSaga(): SagaIterator {
    yield effects.takeEvery(WorkItemActionTypes.WorkItemDeleteSucceeded, closeDeletedWorkItem);
    yield effects.takeEvery(WorkItemActionTypes.WorkItemCreateSucceeded, closeCreatedWorkItem);
}

function* closeDeletedWorkItem(action: ActionsOfType<WorkItemActions, WorkItemActionTypes.WorkItemDeleteSucceeded>) {
    yield effects.put(WorkItemPortalActions.closeWorkItem(action.payload.workItemId));
}

function* closeCreatedWorkItem(action: ActionsOfType<WorkItemActions, WorkItemActionTypes.WorkItemCreateSucceeded>) {
    const { tempWorkItemId } = action.payload;
    if (tempWorkItemId) {
        yield effects.put(WorkItemPortalActions.closeWorkItem(tempWorkItemId));
    }
}
